<ng-container *ngIf="!showError">
  <div
    class="right-panel-header"
    *ngIf="showOnlySourcePanelOnPages.indexOf(pageName) < 0"
  >
    <p>Options</p>
    <span (click)="onClearAllPresetsClicked()" class="clear-preset-btn"
      >Clear All Presets</span
    >
  </div>

  <ng-container>
    <nz-collapse nzAccordion nzBordered="false">
      <!-- Visualizations section start -->

      <div *ngIf="panelVisibility.visualizations">
        <ng-template #visualizationsHeader>
          <div
            class="panelHeader"
            nz-popover
            nzPopoverOverlayClassName="panel-popover"
            nzPopoverContent="Visualize revisions, distribution and earnings surprises"
          >
            <va-icon size="small" name="table"></va-icon>
            <p>Visualizations</p>
            <span
              class="clearBtn"
              (click)="visualizations.handleClear($event)"
              *ngIf="
                visualizations.tempModel &&
                visualizations.tempModel.clearDimension === true
              "
            >
              Clear
            </span>
          </div>
        </ng-template>

        <nz-collapse-panel
          [nzHeader]="visualizationsHeader"
          [nzActive]="activePanel === 'visualizations'"
          [nzShowArrow]="false"
          (nzActiveChange)="handlePanelChange($event, 'visualizations')"
        >
          <app-visualizations #visualizations></app-visualizations>
        </nz-collapse-panel>
      </div>

      <!-- Visualizations section end -->

      <!-- analytics section start -->
      <div *ngIf="panelVisibility.analytics">
        <ng-template #analyticsHeader>
          <div
            class="panelHeader"
            nz-popover
            nzPopoverOverlayClassName="panel-popover"
            nzPopoverContent="See growth rates on a sequential or periodic basis"
          >
            <va-icon size="small" name="chart-line"></va-icon>
            <p>Analytics</p>
            <span
              *ngIf="
                analyticsData.tempModel &&
                analyticsData.tempModel.clearDimension === true
              "
              class="clearBtn"
              (click)="analyticsData.handleClear($event)"
            >
              Clear
            </span>
          </div>
        </ng-template>

        <nz-collapse-panel
          [nzHeader]="analyticsHeader"
          [nzActive]="activePanel === 'analytics'"
          [nzShowArrow]="false"
          (nzActiveChange)="handlePanelChange($event, 'analytics')"
        >
          <app-analytics #analyticsData></app-analytics>
        </nz-collapse-panel>
      </div>
      <!-- analytics section end -->

      <!-- Sources Section Start -->
      <div *ngIf="panelVisibility.sources">
        <ng-container
          *ngIf="
            showOnlySourcePanelOnPages.indexOf(pageName) === -1;
            else sourceListSection
          "
        >
          <ng-template #sourcesHeader>
            <div
              class="panelHeader"
              nz-popover
              nzPopoverOverlayClassName="panel-popover"
              nzPopoverContent="Customize consensus, broker views"
            >
              <va-icon size="small" name="th"></va-icon>
              <p>Sources</p>
              <span
                class="clearBtn"
                *ngIf="
                  sourcePanel.showClear ||
                  (sourcePanelData && sourcePanelData.clear_dimension)
                "
                (click)="sourcePanel.handleClear($event)"
              >
                Clear
              </span>
            </div>
          </ng-template>

          <nz-collapse-panel
            [nzHeader]="sourcesHeader"
            [nzActive]="activePanel === 'sources'"
            [nzShowArrow]="false"
            (nzActiveChange)="handlePanelChange($event, 'sources')"
          >
            <app-source
              [sourcePanelData]="sourcePanelData"
              #sourcePanel
            ></app-source>
          </nz-collapse-panel>
        </ng-container>
      </div>

      <!-- Sources Section End -->

      <!-- Periods section start -->
      <div *ngIf="panelVisibility.periods">
        <ng-template #periodsHeader>
          <div
            class="panelHeader"
            nz-popover
            nzPopoverOverlayClassName="panel-popover"
            nzPopoverContent="Select time periods to see forecasts on"
          >
            <va-icon size="small" name="calendar"></va-icon>
            <p>Periods</p>
            <span
              class="clearBtn"
              (click)="periods.handleClear($event)"
              *ngIf="periods && periods.tempModel.clearDimension === true"
            >
              Clear
            </span>
          </div>
        </ng-template>

        <nz-collapse-panel
          [nzHeader]="periodsHeader"
          [nzActive]="activePanel === 'periods'"
          [nzShowArrow]="false"
          (nzActiveChange)="handlePanelChange($event, 'periods')"
        >
          <app-periods #periods></app-periods>
        </nz-collapse-panel>
      </div>
      <!-- Periods section end -->

      <!-- Historical Estimates section start -->
      <div *ngIf="panelVisibility.historicalEstimates">
        <ng-template #historicalEstimatesHeader>
          <div
            class="panelHeader"
            nz-popover
            nzPopoverOverlayClassName="panel-popover"
            nzPopoverContent="Look up estimates from specific points in time in the past"
          >
            <va-icon isFontAwesome="true" [name]="faHistory"></va-icon>
            <p>Historical Estimates</p>
            <span
              class="clearBtn"
              (click)="historicalEstimates.handleClear($event)"
              *ngIf="
                historicalEstimates &&
                historicalEstimates.tempModel.clearDimension === true
              "
            >
              Clear
            </span>
          </div>
        </ng-template>

        <nz-collapse-panel
          [nzHeader]="historicalEstimatesHeader"
          [nzActive]="activePanel === 'historicalEstimates'"
          [nzShowArrow]="false"
          (nzActiveChange)="handlePanelChange($event, 'historicalEstimates')"
        >
          <app-historical-estimates
            #historicalEstimates
          ></app-historical-estimates>
        </nz-collapse-panel>
      </div>
      <!-- Historical Estimates section end -->
    </nz-collapse>
    <!-- Accounting Basis-->
    <!-- <div
      *ngIf="
        activeCut == 'NMV' && showOnlySourcePanelOnPages.indexOf(pageName) < 0
      "
    >
      <app-accounting-basis></app-accounting-basis>
    </div> -->
    <!-- Accounting Basis End -->

    <!-- only source section for revision and surprise page-->
    <ng-template #sourceListSection>
      <app-source [sourcePanelData]="sourcePanelData"></app-source>
    </ng-template>
  </ng-container>
</ng-container>

<ng-container *ngIf="showError">
  <div class="error-message">
    <va-icon
      isFontAwesome="true"
      [name]="faInfoCircle"
      class="info-icon"
    ></va-icon>
    <span class="error-text">Something went wrong here!</span>
  </div>
</ng-container>
